module.exports = __webpack_public_path__ + "img/LoginBG.ef312334.png";